/** Cuentas que no aplican a esta cooperativa; se ocultan (no se eliminan) en el Excel de Anexo 4. */
export const ANEXO4_CUENTAS_OCULTAS = new Set<string>([
  '697', // OTROS GASTOS
  '5012', // MONEDA EXTRANJERA
  '5022', // MONEDA EXTRANJERA
  '6012', // MONEDA EXTRANJERA
  '6971', // MONEDA NACIONAL
  '501101.0201', // Valores Oficiales
  '501101.0202', // Acciones y Participaciones
  '501101.0314', // Préstamos con Garantía Recíproca Emitida por la SA-FGR
  '501101.0317', // Préstamos a Otras Instituciones
  '501101.020101', // Bonos
  '501101.020102', // Letras
  '501101.020301', // Bursátiles
  '501101.020399', // Inversiones en Otras Instituciones
  '501101.030505', // Créditos con Destino de Vivienda
  '501101.030601', // Agropecuarios
  '501101.030602', // Microcrédito
  '501101.030603', // Comerciales
  '501101.030605', // Créditos con Destino de Vivienda
  '501101.030701', // Agropecuarios
  '501101.030702', // Microcrédito
  '501101.030705', // Créditos con Destino de Vivienda
  '501101.031002', // Microcrédito
  '501101.031101', // Agropecuarios
  '501101.031102', // Microcrédito
  '501101.031201', // Agropecuarios
  '501101.031202', // Microcrédito
  '501101.031203', // Comerciales
  '501101.031205', // Créditos con Destino de Vivienda
  '501101.031301', // Agropecuarios
  '501101.031302', // Microcrédito
  '501101.031701', // Cooperativas de Ahorro y Crédito
  '501101.031799', // Otras
  '501101.031802', // RAP
  '501101.031803', // BCIE
  '501101.031804', // BID
  '501101.031899', // Otros
  '501101.032501', // Agropecuarios
  '501101.032502', // Microcrédito
  '501101.032601', // Agropecuarios
  '501101.032602', // Microcrédito
  '501101.032603', // Comerciales
  '501101.032604', // Consumo
  '501103', // COMISIONES
  '501103.01', // Sobre Cartera Crediticia
  '501103.99', // Comisiones Varias
  '501103.0101', // Comisiones Devengadas
  '501105', // OTROS PRODUCTOS
  '501105.01', // Fluctuaciones de Tipo de Cambio
  '501105.0101', // Activos
  '501105.0102', // Pasivos
  '501199', // Otros Ingresos Financieros
  '501199.99', // Otros Ingresos
  '501201', // INTERESES
  '501201.01', // Sobre Disponibilidades
  '501201.02', // Sobre Inversiones
  '501201.03', // Sobre Cartera de Préstamos
  '501201.0101', // Sobre Depósitos a la Vista
  '501201.0102', // Sobre Depósitos de Ahorros
  '501201.0201', // Valores Oficiales
  '501201.0202', // Acciones y Participaciones
  '501201.0203', // Valores Diversos
  '501201.0305', // Préstamos Fiduciarios
  '501201.0306', // Préstamos Automáticos
  '501201.0307', // Préstamos Prendarios
  '501201.0310', // Préstamos Hipotecarios
  '501201.0311', // Préstamos Con Garantía Mixta
  '501201.0312', // Préstamos Refinanciados
  '501201.0313', // Préstamos Readecuados
  '501201.0314', // Préstamos con Garantía Recíproca Emitida por la SA-FGR
  '501201.0317', // Préstamos a Otras Instituciones
  '501201.0318', // Préstamos con Fondos Redescontados
  '501201.0325', // Préstamos Refinanciados por Emergencia Sanitaria COVID-19
  '501201.0326', // Préstamos Readecuados por Emergencia Sanitaria COVID-19
  '501201.020101', // Bonos
  '501201.020102', // Letras
  '501201.020301', // Bursátiles
  '501201.020302', // Depósitos a Plazo
  '501201.020399', // Inversiones en Otras Instituciones
  '501201.030501', // Agropecuarios
  '501201.030502', // Microcrédito
  '501201.030503', // Comerciales
  '501201.030504', // Consumo
  '501201.030505', // Créditos con Destino de Vivienda
  '501201.030601', // Agropecuarios
  '501201.030602', // Microcrédito
  '501201.030603', // Comerciales
  '501201.030604', // Consumo
  '501201.030605', // Créditos con Destino de Vivienda
  '501201.030701', // Agropecuarios
  '501201.030702', // Microcrédito
  '501201.030703', // Comerciales
  '501201.030704', // Consumo
  '501201.030705', // Créditos con Destino de Vivienda
  '501201.031001', // Agropecuarios
  '501201.031002', // Microcrédito
  '501201.031003', // Comerciales
  '501201.031004', // Consumo
  '501201.031005', // Créditos para Vivienda
  '501201.031101', // Agropecuarios
  '501201.031102', // Microcrédito
  '501201.031103', // Comerciales
  '501201.031104', // Consumo
  '501201.031105', // Créditos con Destino de Vivienda
  '501201.031201', // Agropecuarios
  '501201.031202', // Microcrédito
  '501201.031203', // Comerciales
  '501201.031204', // Consumo
  '501201.031205', // Créditos con Destino de Vivienda
  '501201.031301', // Agropecuarios
  '501201.031302', // Microcrédito
  '501201.031303', // Comerciales
  '501201.031304', // Consumo
  '501201.031305', // Créditos con Destino de Vivienda
  '501201.031701', // Cooperativas de Ahorro y Crédito
  '501201.031799', // Otras
  '501201.031801', // BANHPROVI
  '501201.031802', // RAP
  '501201.031803', // BCIE
  '501201.031804', // BID
  '501201.031899', // Otros
  '501201.032501', // Agropecuarios
  '501201.032502', // Microcrédito
  '501201.032503', // Comerciales
  '501201.032504', // Consumo
  '501201.032505', // Créditos con Destino de Vivienda
  '501201.032601', // Agropecuarios
  '501201.032602', // Microcrédito
  '501201.032603', // Comerciales
  '501201.032604', // Consumo
  '501201.032605', // Créditos con Destino de Vivienda
  '501203', // COMISIONES
  '501203.01', // Sobre Cartera Crediticia
  '501203.99', // Comisiones Varias
  '501203.0101', // Comisiones Devengadas
  '501299', // Otros Ingresos Financieros
  '501299.99', // Otros Ingresos
  '502102', // ARRENDAMIENTOS
  '502102.01', // Alquiler de Activos Fijos
  '502201', // COMISIONES
  '502201.01', // Remesas
  '502201.02', // Cobranzas por Cuenta Ajena
  '502201.99', // Otras Comisiones
  '503101', // Venta de Activos Eventuales
  '503102', // Ventas de Bienes Muebles e Inmuebles
  '503103', // Donaciones Recibidas
  '503104', // Intereses Cobrados sobre Operaciones Readecuadas
  '503198', // Donaciones Recibidas
  '503199', // OTROS PRODUCTOS
  '601101.08', // Préstamos de Instituciones Financieras Nacionales
  '601101.14', // Préstamos de Instituciones Internacionales
  '601101.99', // Otras Obligaciones
  '601102', // COMISIONES
  '601102.02', // Préstamos de Instituciones Financieras Nacionales
  '601102.96', // Préstamos de Instituciones Internacionales
  '601102.99', // Otras Comisiones
  '601105', // OTROS GASTOS
  '601105.01', // Fluctuaciones de Tipo de Cambio
  '601105.0101', // Activos
  '601105.0102', // Pasivos
  '601199', // OTROS GASTOS FINANCIEROS
  '601199.99', // OTROS GASTOS
  '601201', // INTERESES
  '601201.02', // DEPÓSITOS DE AHORRO
  '601201.03', // Depósitos a Plazo
  '601201.08', // Préstamos de Instituciones Financieras Nacionales
  '601201.13', // Préstamos Redescontados
  '601201.14', // Préstamos de Instituciones Internacionales
  '601201.15', // APORTACIONES
  '601201.99', // Otras Obligaciones
  '601202', // COMISIONES
  '601202.02', // Préstamos de Instituciones Financieras Nacionales
  '601202.96', // Préstamos de Instituciones Internacionales
  '601202.99', // Otras Comisiones
  '602101.01', // Asamblea General
  '602101.0101', // Convocatorias
  '602101.0102', // Memorias e Informes
  '602101.0103', // Alimentación
  '602101.0104', // Premios y Obsequios
  '602101.0105', // Alquileres y Arreglo de local
  '602101.0106', // Transporte
  '602101.0199', // Otros
  '602101.0202', // Gastos de Representación
  '602101.0204', // Viáticos
  '602101.0302', // Gastos de Representación
  '602101.0304', // Viáticos
  '602102.02', // Sueldos Extraordinarios
  '602102.06', // Gastos de Representación
  '602102.13', // Seguro de Plan de Retiro
  '602102.0304', // Incentivos del Personal
  '602102.0803', // Otros Gastos de Viaje
  '602102.0902', // INFOP
  '602103.03', // Contribución Especial de Seguridad Poblacional
  '602104.01', // Auditoría Externa
  '602104.03', // Asesoría Técnica
  '602105.02', // MOBILIARIO Y EQUIPO DE OFICINA
  '602105.03', // Sistema de Informática
  '602105.05', // Vehículos
  '602106.06', // Edificios Arrendados
  '602106.99', // Otros
  '602107', // SEGURIDAD Y VIGILANCIA
  '602107.01', // SEGURIDAD Y VIGILANCIA
  '602108.01', // Estudios de Mercado
  '602108.99', // Otros
  '602109.05', // Seguro de Cartera de Préstamos
  '602109.99', // Otros
  '602110.0201', // PROVISIÓN PARA CRÉDITOS DUDOSOS
  '602110.0202', // PROVISIÓN PARA INTERESES DUDOSOS
  '602110.0203', // Amortización sobre Inversiones
  '602110.0205', // Amortización sobre Gastos de Organización e Instalación
  '602110.0206', // Amortización sobre Activos de Inversión
  '602110.0208', // Provisión sobre Cuentas y Documentos por Cobrar
  '602110.020101', // Agropecuarios
  '602110.020102', // Microcréditos
  '602110.020103', // Comerciales
  '602110.020104', // Consumo
  '602110.020105', // Créditos con Destino de Vivienda
  '602110.020106', // Créditos para Vivienda
  '602110.020201', // Agropecuarios
  '602110.020202', // Microcréditos
  '602110.020203', // Comerciales
  '602110.020204', // Consumo
  '602110.020205', // Créditos con Destino de Vivienda
  '602110.020206', // Créditos para Vivienda
  '602199.02', // Cuotas y Asociaciones Varias
  '602199.03', // Donaciones y Contribuciones Voluntarias
  '602199.05', // Aportaciones de Supervisión
  '602199.98', // Aportaciones al Fondo de Seguro de Depósitos
  '697101', // Venta de Activos Eventuales
  '697102', // Ventas de Bienes Muebles e Inmuebles
  '697103', // Sanciones, Multas e Indemnizaciones
  '697199', // OTROS GASTOS
  '697199.99', // Otros
]);
